export default function FileUpload({ onFileChange, isProcessing,baseUrl }) {
  return (
    <>
      <label htmlFor="upload-pipe" className="btn btn-primary fw-semibold mb-2">
        <i className="bi bi-file-earmark-plus-fill me-2"></i>Add PDF Files
      </label>
      <input id="upload-pipe" type="file" accept="application/pdf" multiple className="d-none" onChange={onFileChange} disabled={isProcessing} />
    </>
  );
}
